/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const accessibility = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M8 6.77v2.992M8 6.77l4-1.102M8 6.769 4 5.667m4 4.095L10.962 15M8 9.762 5.038 15M9.714 2.75c0 .966-.767 1.75-1.714 1.75s-1.714-.784-1.714-1.75S7.053 1 8 1s1.714.784 1.714 1.75Z"
    />
  </svg>
)
export default accessibility
